<div class="container">

  <div class="grid container-header">
    <div class="col-12 md:col-12 lg:col-6">
      <span class="title">{{ 'TRANSLATE.NEW.COVERAGE' | translate }}</span>
    </div>
  </div>

  <div class="container-body">
    <form [formGroup]="userform" (ngSubmit)="buttonSave()">

      <div class="new-product-itens">

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">
          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first">
            <label class="element-add-edit-filter" for="country">{{ 'TRANSLATE.COUNTRY' | translate }}</label>
            <p-dropdown [options]="listCountries" id="country" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [autoDisplayFirst]="false" formControlName="optionCountry" (onChange)="countryChange($event)"
              [style]="{'minWidth': '100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && selectedCountry === null) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.SELECT.COUNTRY' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-8 element-add-edit space-second field-wide">
            <label class="element-add-edit-filter" for="productId">{{ 'TRANSLATE.PRODUCT.CODE' | translate }}</label>
            <p-autoComplete [placeholder]="placeholderProduct | translate" [suggestions]="productActiveCountries"
              id="productId" formControlName="optionProductName" (completeMethod)="searchProducts($event)"
              (onSelect)="onProductSelect($event)" field="name" [showEmptyMessage]="false"
              [style]="{'width': '100%'}" appendTo="body" [dropdown]="true" autoHighlight>
              <ng-template pTemplate="item" let-item>
                <div class="product-item">
                  <span>{{ formatProductIdName(item) }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="empty">
                <div class="p-p-3">
                  {{ 'TRANSLATE.NO.RESULT.FOUND' | translate }}
                </div>
              </ng-template>
            </p-autoComplete>

            @if (!selectedCountry) {
            <small class="field-hint">
              {{ 'TRANSLATE.SELECT.COUNTRY.FIRST' | translate }}
            </small>
            }

            @if (selectedCountry && !isLoadingProducts && !productActiveCountries.length) {
            <small class="field-hint">
              {{ 'TRANSLATE.NO.RESULT.FOUND' | translate }}
            </small>
            }

            @if (submitted && userform.get('optionProductName')?.enabled && selectedProductName === null) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.NAME.PRODUCT' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-6 element-add-edit space-second">
            <label class="element-add-edit-filter" for="type">{{ 'TRANSLATE.TYPE.COVERAGE' | translate }}</label>
            <p-dropdown [options]="listTypeCoverage" id="type" placeholder="{{ 'TRANSLATE.SELECT' | translate }}"
              [autoDisplayFirst]="false" formControlName="optionCoverageType"
              (onChange)="optionCoverageTypeChange($event)" [style]="{'minWidth': '100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                {{ item?.label ? (item.label | translate) : ('TRANSLATE.SELECT' | translate) }}
              </ng-template>
            </p-dropdown>

            @if (submitted && selectedCoverageType === null) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECT.TYPE.COVERAGE' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-6 element-add-edit space-first top-space field-wide">
            <label class="element-add-edit-label" for="coverageName">{{ 'TRANSLATE.COVERAGE.NAME' | translate }}</label>
            <input class="element-add-edit-input large-text" id="coverageName" formControlName="inputCoverageName"
              type="text" maxlength="20" pInputText>

            @if (hasControlRequiredError('inputCoverageName')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.COVERAGE.NAME' | translate }}">
            </p-message>
            } @else if (hasControlMinLengthError('inputCoverageName')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.COVERAGE.NAME' | translate }}">
            </p-message>
            }
          </div>

        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">
          <div class="col-12 md:col-12 lg:col-12 element-add-edit space-first textarea-row">
            <label class="element-add-edit-label" for="coverageDescription">{{ 'TRANSLATE.COVERAGE.DESCRIPTION' |
              translate }}</label>
            <textarea class="element-add-edit-input large-text" id="coverageDescription"
              formControlName="inputCoverageDescription" type="text" maxlength="100" pInputTextarea></textarea>

            <div class="char-counter">
              {{ userform.get('inputCoverageDescription')?.value?.length || 0 }} {{ 'TRANSLATE.MAX.CHARACTERS.100' |
              translate }}
            </div>
            @if (hasControlRequiredError('inputCoverageDescription')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DESCRIPTION.COVERAGE' | translate }}">
            </p-message>
            } @else if (hasControlMinLengthError('inputCoverageDescription')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.COVERAGE.DESCRIPTION' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first">
            <label class="element-add-edit-label" for="owsCoverage">{{ 'TRANSLATE.OWS.COVERAGE' | translate }}</label>
            <input class="element-add-edit-input large-text" id="owsCoverage" formControlName="inputOwsCoverage"
              type="text" maxlength="8" oninput="this.value = this.value.toUpperCase()" pInputText>

            @if (hasControlRequiredError('inputOwsCoverage')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.OWS.COVERAGE' | translate }}">
            </p-message>
            } @else if (hasControlMinLengthError('inputOwsCoverage')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.MIN.LENGTH.OWS.COVERAGE' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-fourth">
            <label class="element-add-edit-label" for="months">{{ 'TRANSLATE.MONTHS' | translate }}</label>
            <input class="element-add-edit-input" id="months" formControlName="inputMonths" type="text" maxlength="2"
              (input)="formatNumber($event)" pInputText>

            @if (hasControlRequiredError('inputMonths')) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.INFORM.MONTHS' | translate }}">
            </p-message>
			} @else if (hasControlGreaterThanZeroError('inputMonths')) {
			<p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
			</p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-fourth">
            <label class="element-add-edit-label" for="distance">{{ 'TRANSLATE.DISTANCE' | translate }}</label>
            <input class="element-add-edit-input" id="distance" formControlName="inputDistance" type="text"
              maxlength="7" (input)="formatOdometerNumber($event)" pInputText>
            @if (hasControlRequiredError('inputDistance')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.DISTANCE' | translate }}">
            </p-message>
			} @else if (hasControlGreaterThanZeroError('inputDistance')) {
			<p-message class="client-data-message" severity="error"
			  text="{{ 'TRANSLATE.MUST.BE.GREATER.THAN.ZERO' | translate }}">
			</p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first">
            <label class="element-add-edit-label" for="visits">{{ 'TRANSLATE.TOTAL.VISITS' | translate }}</label>
            <input class="element-add-edit-input" id="visits" formControlName="inputTotalVisits" type="text"
              maxlength="2" (input)="formatNumber($event)" pInputText>

            @if (userform.controls['inputTotalVisits'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.TOTAL.VISITS' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-fourth">
            <label class="element-add-edit-label" for="startVisit">{{ 'TRANSLATE.INITIAL.VISIT' | translate }}</label>
            <input class="element-add-edit-input" id="startVisit" formControlName="inputInitialVisit" type="text"
              maxlength="2" (input)="formatNumber($event)" pInputText>

            @if (userform.controls['inputInitialVisit'].pending) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.INITIAL.VISIT' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-fourth">
            <label class="element-add-edit-filter" for="account">{{ 'TRANSLATE.ACCOUNT.ENGLISH' | translate }}</label>

            <p-dropdown [options]="listAccountCodeOWS" id="account" [autoDisplayFirst]="false" [showClear]="true"
              formControlName="optionAccount" (onChange)="accountOnChange($event)"
              [placeholder]="(placeholderAccountCode || 'TRANSLATE.SELECT') | translate" [editable]="editableAccount"
              [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>
            @if (userform.get('optionAccount')?.disabled) {
            <small class="field-hint">
              {{ 'TRANSLATE.SELECT.PRODUCT.FIRST' | translate }}
            </small>
            }
            @if (userform.get('optionAccount')?.enabled && messageAccountCode === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }
          </div>
        </div>

        <div class="col-12 md:col-12 lg:col-12 new-product-itens-lines">

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-first">
            <label class="element-add-edit-filter" for="actionCode">{{ 'TRANSLATE.ACTION.ENGLISH' | translate }}</label>

            <p-dropdown [options]="listActionCodeOWS" id="actionCode" [autoDisplayFirst]="false" [showClear]="true"
              formControlName="optionActionCode" (onChange)="actionCodeOnChange($event)"
              [placeholder]="(placeholderActionCodeOWS || 'TRANSLATE.SELECT') | translate"
              [editable]="editableActionCodeOWS" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>
            @if (userform.get('optionActionCode')?.disabled) {
            <small class="field-hint">
              {{ 'TRANSLATE.SELECT.PRODUCT.FIRST' | translate }}
            </small>
            }
            @if (userform.get('optionActionCode')?.enabled && messageActionCodeOWS === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-fourth">
            <label class="element-add-edit-filter" for="coverageCode">{{ 'TRANSLATE.COVERAGE.ENGLISH' | translate
              }}</label>

            <p-dropdown [options]="listCoverageCodeOWS" id="coverageCode" [autoDisplayFirst]="false" [showClear]="true"
              formControlName="optionCoverageCode" (onChange)="coverageCodeOnChange($event)"
              [placeholder]="(placeholderCoverageCodeOWS || 'TRANSLATE.SELECT') | translate"
              [editable]="editableCoverageCodeOWS" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>
            @if (userform.get('optionCoverageCode')?.disabled) {
            <small class="field-hint">
              {{ 'TRANSLATE.SELECT.PRODUCT.FIRST' | translate }}
            </small>
            }
            @if (userform.get('optionCoverageCode')?.enabled && messageCoverageCodeOWS === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }
          </div>

          <div class="col-12 md:col-6 lg:col-4 element-add-edit space-fourth">
            <label class="element-add-edit-filter" for="insuranceCode">{{ 'TRANSLATE.INSURANCE.ENGLISH' | translate
              }}</label>

            <p-dropdown [options]="listInsuranceCode" id="insuranceCode" [autoDisplayFirst]="false" [showClear]="true"
              formControlName="optionInsuranceCode" (onChange)="insuranceCodeOnChange($event)"
              [placeholder]="(placeholderInsuranceCode || 'TRANSLATE.SELECT') | translate"
              [editable]="editableInsuranceCode" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
            </p-dropdown>
            @if (userform.get('optionInsuranceCode')?.disabled) {
            <small class="field-hint">
              {{ 'TRANSLATE.SELECT.PRODUCT.FIRST' | translate }}
            </small>
            }
            @if (userform.get('optionInsuranceCode')?.enabled && messageInsuranceCode === true) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.A.NEW.OPTION' | translate }}">
            </p-message>
            }
            @if (submitted && userform.get('optionInsuranceCode')?.enabled &&
            userform.get('optionInsuranceCode')?.hasError('required')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORM.INSURANCE.CODE' | translate }}">
            </p-message>
            }
          </div>

        </div>

      </div>

      <div class="actions-section">
        <div class="col-12 md:col-12 lg:col-12 button-position">

          <button id="btnReturn" class="btn-return app-clean-button" type="button" (click)="buttonReturn()"
            [disabled]="isSaving">
            <i class="pi pi-arrow-left"></i>
            <span class="btn-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
          </button>

          <app-cta-button [label]="'TRANSLATE.SAVE'" [loadingLabel]="'TRANSLATE.SAVING'" [successState]="isCtaSuccess"
            [loading]="isSaving" (buttonClick)="buttonSave()">
          </app-cta-button>

        </div>
      </div>

    </form>
  </div>

</div>